// only whitelist these vaults on testnet created before the TESTNET_WHITELIST_TIMESTAMP
export const HDRO_MARKET_ID =
  '0xc8fafa1fcab27e16da20e98b4dc9dda45320418c27db80663b21edac72f3b597'
export const QUNT_MARKET_ID =
  '0x42edf70cc37e155e9b9f178e04e18999bc8c404bd7b638cc4cbf41da8ef45a21'
export const PHUC_MARKET_ID =
  '0x697457537bc2af5ff652bc0616fe23537437a570d0e4d91566f03af279e095d5'
export const BLACK_MARKET_ID =
  '0xd166688623206f9931307285678e9ff17cecd80a27d7b781dd88cecfba3b1839'
export const BTORO_MARKET_ID =
  '0x5de59857f03c90cdb364edcf99963c50b732bbd7a715430fd36f35a21a8bd54b'

// Record<MarketId, string>
export const launchpadDescriptionMapping: Record<string, string> = {
  '0x5777730c1ab6f6b1e465d41778562ada8c136c0f11ffbbdb2faa7a5bbde5d5a5':
    'Project X is the first token natively minted on Mito Finance testnet.',
  '0x382a1cf37bcdbccd5698753154335fa56651d64b88b054691648710c8dcf43e0':
    'To celebrate Mito Launchpad open for Zen NFT holders, ZEN has now become the second token natively minted on Mito Finance testnet.',
  [PHUC_MARKET_ID]:
    'Quants is an INJ burning NFT that represents the largest community of traders.\n$QUNT will sit on faces.',
  [QUNT_MARKET_ID]:
    'Quants is an INJ burning NFT that represents the largest community of traders.\n$QUNT will sit on faces.',
  [HDRO_MARKET_ID]:
    'Hydro Protocol is the ultimate infrastructure platform for yield and liquidity strategies on the Injective Network.',
  [BLACK_MARKET_ID]:
    'Black Panther is the leading AI driven asset management protocol building on Injective.',
  [BTORO_MARKET_ID]:
    'Bitoro Network is a leveraged trading protocol and liquidity aggregator for the perpetual futures market.'
}

export const launchpadProjectNameMapping: Record<string, string> = {
  [PHUC_MARKET_ID]: 'Quants',
  [QUNT_MARKET_ID]: 'Quants',
  [HDRO_MARKET_ID]: 'Hydro',
  [BTORO_MARKET_ID]: 'Bitoro'
}

export const launchpadStakingDescriptionMapping: Record<string, string> = {
  [PHUC_MARKET_ID]:
    'The Quants team has created a special whitelist to reward early community members. QUNT will be available initially only to Quants NFT holders. A snapshot of eligible Injective wallets was taken on February 20, 2024 at 12:50 PM UTC.',
  [QUNT_MARKET_ID]:
    'The Quants team has created a special whitelist to reward early community members. QUNT will be available initially only to Quants NFT holders. A snapshot of eligible Injective wallets was taken on February 20, 2024 at 12:50 PM UTC.'
}

export const launchpadProjectDescriptionMapping: Record<string, string> = {
  [PHUC_MARKET_ID]: 'Qunt',
  [QUNT_MARKET_ID]: 'Qunt',
  [HDRO_MARKET_ID]: 'Hydro',
  [BLACK_MARKET_ID]: 'Black',
  [BTORO_MARKET_ID]: 'Bitoro'
}

export const launchpadRequirementDescriptionMapping: Record<string, string> = {
  [PHUC_MARKET_ID]: 'Qunt',
  [QUNT_MARKET_ID]: 'Qunt'
}

export const testnetWhitelistedIDOs: string[] = []

// beta launchpads
export const testnetBlacklistedMarketId: string[] = [
  '0xba7096c2c49b845e6bfc8317e88831c15786bee3149836dde55481abd5ef040b', // MITOTEST1-INJ
  '0x382a1cf37bcdbccd5698753154335fa56651d64b88b054691648710c8dcf43e0' // ZEN-INJ
]

export const mainnetWhitelistedIDOs: string[] = [
  'inj1g7tqrc7dv9zaxdjrjwdscuyl508fqmcpj7e2cd', // QUNT
  'inj1cpwphh4zvehcd4vrvxrpn8zdve4sl8x69cpem2', // HDRO
  'inj19522dnf8wl4usnxkexylt37tcrauewzwral98h', // BLACK
  'inj1k5lh683q4484phshl678tdfhtgkp4t6ta8kvsr' // BTORO
]

export const hideClaimedTokenVaults: string[] = [
  'inj1g7tqrc7dv9zaxdjrjwdscuyl508fqmcpj7e2cd', // QUNT
  'inj1cpwphh4zvehcd4vrvxrpn8zdve4sl8x69cpem2' // HDRO
]

export const mainnetBlacklistedIDOs: string[] = [
  'inj18l6gft3mqrh02fdhrqvln2pa2wkz7u69ltwsda', // Phuc Test 1
  'inj1r980palfkvyv2gc96n9jwmr60mrqdkgppq6tja', // Phuc Test 2
  'inj1p72233jupjqfnm03e986uk4wqrrdetv4qcrded' // Phuc Test 3
]
